import { render, staticRenderFns } from "./BottomControlsNavBar.vue?vue&type=template&id=d50c4ee2&"
import script from "./BottomControlsNavBar.vue?vue&type=script&lang=js&"
export * from "./BottomControlsNavBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomControlsNavBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VCard,VContainer,VIcon})
